@if(customButtonStyles){
    <button
            (click)="onClick.emit({trigger: customButtonStyles.trigger, amount: customButtonStyles.amount})"
            class="border-primary border hover:opacity-100 hover:bg-primary-hover opacity-90 p-3 text-center text-base font-medium flex justify-center gap-4 rounded-md w-full"
            [ngStyle]="{
    'background': customButtonStyles.styles?.background,
    'color': customButtonStyles?.styles?.textColor
  }"
    >
        @if(customButtonStyles?.styles?.icon){
            <img [src]="customButtonStyles.styles.icon" [alt]="customButtonStyles?.title" class="object-contain object-center" width="24" height="24" />
        }
        {{customButtonStyles.title | translate}}
    </button>
}
